import { useRouter } from 'next/router';
import { useIsWhiteLabel } from '../app/providers/whiteLabelProvider/WhiteLabelProvider';
import { SearchDataProps } from '../search/_types/searchDataType';
import useDevice from '@/hooks/useDevice';
import { useEffect, useState } from 'react';
import { fetchMainQueryLanding } from '../reusable/mainQueriesLandings/reusable/_helpers/fetchData';
import LogoContainer from '../search/logoContainer/LogoContainer';
import Header from '../layout/header/Header';
import NavigationBar from '../layout/NavigationBar/NavigationBar';
import SelectCheckinPopUp from '../search/selectCheckinPopUp/SelectCheckinPopUp';
import Products from '../reusable/mainQueriesLandings/reusable/products/Products';
import Filters from '../reusable/mainQueriesLandings/reusable/filters/Filters';
export interface SearchDataType {
  loading: boolean;
  data: SearchDataProps;
}
const SearchDefaultData: SearchDataProps = {
  list: null,
  map_list: null,
  midterm_map_list: null,
  loading: false,
  region_data: null,
  pagination: {
    total: 0,
    current_page: 0
  },
  search_id: ''
};
const perPage = 24;
const AllCottage = ({
  firstData,
  isBot
}) => {
  const isWhiteLabel = useIsWhiteLabel();
  const router = useRouter();
  const {
    isMobile
  } = useDevice();
  const [searchData, setSearchData] = useState<SearchDataType>({
    loading: true,
    data: firstData
  });
  useEffect(() => {
    const handleFetchData = async () => {
      if (!isBot) {
        if (firstData?.list?.length > 0) {
          setSearchData({
            loading: true,
            data: SearchDefaultData
          });
          try {
            const result = await fetchMainQueryLanding({
              query: router.query,
              perPage,
              pageContent: 'cottage'
            });
            setSearchData({
              loading: false,
              data: result
            });
          } catch (error) {
            setSearchData(prev => ({
              ...prev,
              loading: false
            }));
          }
        }
      } else {
        setSearchData({
          loading: false,
          data: firstData
        });
      }
    };
    handleFetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.asPath.split('#')[0]]);
  return <>
      {!isMobile ? <Header defaultLightMode /> : !isWhiteLabel && <LogoContainer />}
      {(!router.query.host_uid || !isMobile) && <Filters />}
      <Products perPage={perPage} data={searchData.data} loading={searchData.loading} firstData={firstData} isBot={isBot} data-sentry-element="Products" data-sentry-source-file="AllCottage.tsx" />
      {isMobile && <>
          <NavigationBar />
          <SelectCheckinPopUp />
        </>}
    </>;
};
export default AllCottage;